import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-container">
            <header className="policy-header">
        <h1>Privacy Policy</h1>
        <p className="last-updated">Last Updated: [Date]</p>
      </header>

      
      <section className="policy-section">
        <h2>Introduction</h2>
        <p>
          This Privacy Policy describes how KAAMVALA JOBS and SERVICES ("we", "our", "us") collect, use, 
          share, protect or otherwise process your information through our website (<a href="https://kaamvala.com/">https://kaamvala.com/</a>) 
          and its affiliated platforms.
        </p>
        <p>
          We do not offer any product/service under this Platform outside India and your personal data will 
          primarily be stored and processed in India. By using our Platform, you agree to be bound by this 
          Privacy Policy and the applicable laws of India.
        </p>
      </section>

      <section className="policy-section">
        <h2>Information We Collect</h2>
        <p>We may collect the following types of information:</p>
        <ul className="policy-list">
          <li>Personal identification information (name, date of birth, address, contact details)</li>
          <li>Payment information (when you make transactions)</li>
          <li>Biometric information (only with your explicit consent for specific features)</li>
          <li>Usage data and preferences</li>
          <li>Transaction history</li>
        </ul>
        <p>
          You always have the option to not provide information by choosing not to use specific features of the Platform.
        </p>
      </section>

      <section className="policy-section">
        <h2>How We Use Your Information</h2>
        <p>We use your information to:</p>
        <ul className="policy-list">
          <li>Provide and improve our services</li>
          <li>Process transactions</li>
          <li>Enhance user experience</li>
          <li>Prevent fraud and ensure security</li>
          <li>Communicate with you about offers and updates</li>
          <li>Comply with legal obligations</li>
        </ul>
      </section>

      <section className="policy-section">
        <h2>Information Sharing</h2>
        <p>We may share your information with:</p>
        <ul className="policy-list">
          <li>Our group companies and affiliates</li>
          <li>Service providers and business partners</li>
          <li>Law enforcement agencies when required by law</li>
        </ul>
        <p>
          We require third parties to maintain appropriate security measures to protect your information.
        </p>
      </section>

      <section className="policy-section">
        <h2>Security Measures</h2>
        <p>We implement reasonable security practices to protect your information, including:</p>
        <ul className="policy-list">
          <li>Secure servers and encryption</li>
          <li>Access controls</li>
          <li>Regular security assessments</li>
        </ul>
        <p>
          However, no internet transmission is 100% secure, and we cannot guarantee absolute security.
        </p>
      </section>

      <section className="policy-section">
        <h2>Data Retention</h2>
        <p>
          We retain your personal information only as long as necessary for the purposes outlined in this policy 
          or as required by law. You may request deletion of your account and associated data through your 
          profile settings or by contacting us.
        </p>
      </section>

      <section className="policy-section">
        <h2>Your Rights</h2>
        <p>You have the right to:</p>
        <ul className="policy-list">
          <li>Access and update your personal information</li>
          <li>Delete your account and associated data</li>
          <li>Withdraw consent for data processing</li>
          <li>Opt-out of marketing communications</li>
        </ul>
      </section>
      <section className="policy-section">
        <h3>Return Policy</h3>
        <p>We offer refund/exchange within first 5 days from the date of your purchase. If 5 days have passed since your purchase, you will not be offered a return, exchange or refund of any kind.</p>
        
        <p>In order to become eligible for a return or an exchange:</p>
        <ul className="policy-list">
          <li>The purchased item should be unused and in the same condition as you received it</li>
          <li>The item must have original packaging</li>
          <li>If the item that you purchased on a sale, then the item may not be eligible for a return/exchange</li>
        </ul>
        
        <p>Further, only such items are replaced by us (based on an exchange request), if such items are found defective or damaged.</p>
        
        <p>You agree that there may be certain categories of products/items that are exempted from returns or refunds. Such categories of the products would be identified to you at the time of purchase.</p>
        
        <p>For exchange/return accepted request(s) (as applicable), once your returned product/item is received and inspected by us, we will send you an email to notify you about receipt of the returned/exchanged product. Further, if the same has been approved after the quality check at our end, your request (i.e. return/exchange) will be processed in accordance with our policies.</p>
      </section>

      <section className="policy-section">
        <h3>Shipping Policy</h3>
        <p>The orders for the user are shipped through registered domestic courier companies and/or speed post only. Orders are shipped within 1 day from the date of the order and/or payment or as per the delivery date agreed at the time of order confirmation and delivering of the shipment, subject to courier company/post office norms.</p>
        
        <p>Platform Owner shall not be liable for any delay in delivery by the courier company/postal authority. Delivery of all orders will be made to the address provided by the buyer at the time of purchase.</p>
        
        <p>Delivery of our services will be confirmed on your email ID as specified at the time of registration. If there are any shipping cost(s) levied by the seller or the Platform Owner (as the case be), the same is not refundable.</p>
      </section>

      <section className="policy-section">
        <h2>Contact Us</h2>
        <div className="contact-info">
          <p><strong>Grievance Officer:</strong></p>
          <p>Name: [Officer Name]</p>
          <p>Email: [Contact Email]</p>
          <p>Phone: [Contact Number] (Monday-Friday, 9:00 AM - 6:00 PM)</p>
          <p>Address: [Company Address]</p>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;